import { render, staticRenderFns } from "./MemberBankSection.vue?vue&type=template&id=edaa741c"
import script from "./MemberBankSection.vue?vue&type=script&lang=js"
export * from "./MemberBankSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports